export default __webpack_public_path__ + "static/media/rmcm05.b21798a6.png";